import React, { ReactNode } from 'react';

import { FieldContainer, FieldEmotion, Label } from '../Input/styles';
import { TextareaEmotion } from './styles';
import { Hint, viewHint } from '../Hint';

export interface TextareaProps {
  label?: string;
  id: string;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  rows?: number;
  readOnly?: boolean;
  isDisabled?: boolean;
  autoFocus?: boolean;
  required?: boolean;
  hint?: ReactNode;
  hintInfo?: ReactNode;
  hintError?: ReactNode;
  hintWarning?: ReactNode;
  hintView?: typeof viewHint[number];
  hintPosition?: 'top' | 'bottom' | 'left' | 'right' | 'default';
}

export function Textarea(props: TextareaProps) {
  const {
    label,
    id,
    placeholder,
    rows = 8,
    readOnly,
    isDisabled,
    autoFocus,
    required,
    hint,
    hintInfo,
    hintError,
    hintWarning,
    hintView = 'error',
    hintPosition = 'right'
  } = props;

  const isHintVisible = !!hint || !!hintInfo || !!hintError || !!hintWarning;

  const getHint = () => {
    let hintToRender = hint;
    let hintToRenderView = hintView;

    if (hintInfo) {
      hintToRender = hintInfo;
      hintToRenderView = 'info';
    }

    if (hintWarning) {
      hintToRender = hintWarning;
      hintToRenderView = 'warning';
    }

    if (hintError) {
      hintToRender = hintError;
      hintToRenderView = 'error';
    }

    return (
      hintToRender && (
        <Hint view={hintToRenderView} position={hintPosition}>
          {hintToRender}
        </Hint>
      )
    );
  };

  return (
    <FieldContainer isHintDefault={hintPosition === 'default'} isHintVisible={isHintVisible}>
      <FieldEmotion autoHeight={true} isDisabled={isDisabled}>
        {label && <Label htmlFor={id}>{label}</Label>}
        <TextareaEmotion
          placeholder={placeholder}
          rows={rows}
          readOnly={readOnly}
          disabled={isDisabled}
          autoFocus={autoFocus}
          required={required}
          {...props}
        />
      </FieldEmotion>

      {getHint()}
    </FieldContainer>
  );
}
